import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaTruck,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaArrowRight,
} from "react-icons/fa";
import {
  

  FaUsers,
  
} from "react-icons/fa";
import {
  FaTools,
  FaUserTie,
  FaAward,
  FaBuilding,
} from "react-icons/fa";
import {
  FaTruckMoving,
  FaTractor,
  FaHardHat,
} from "react-icons/fa";
import "../css/Home.css";
const categories = [
  {
    title: "COMBINE HARVESTER",
    image:
      "https://www.mahindratractor.com/sites/default/files/styles/1532x912/public/2025-03/Blog-6-How%20to%20choose%20the%20right%20combine%20harvester%20machine%20for%20your%20farm-Detail_0.webp?itok=U1iodxN8",
  },
  {
    title: "TRACTOR",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqph87erjY4szb3PkugrKcKnQGUrzPnMs0pohPUzLZbCsmbAOoleI-t5VR&s=10",
  },
  {
    title: "WHEAT HARVESTER",
    image:
      "https://img.magnific.com/free-photo/aerial-drone-view-harvester-gathering-crops_1268-20615.jpg?semt=ais_hybrid&w=740&q=80",
  },
  {
    title: "CROP HARVESTER",
    image:
      "https://img.magnific.com/premium-photo/modern-agricultural-equipment-field_392895-811908.jpg?semt=ais_hybrid&w=740&q=80",
  },
  {
    title: "CLAAS CROP TIGER",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUaHfdyBH4XnlXLWHw_SSNvmnimK7QqhtSjLdkkuyfAghkNYFWRGXXNTn3&s=10",
  },
  {
    title: "TERRA TRAC",
    image:
      "https://www.heavy-equipmentmanual.com/cdn/shop/products/Operator_s_manual_for_Claas_CROP_TIGER_40_TERRA_TRAC_combine_harvester.jpg?v=1557810409",
  },
];

const Home = () => {
  return (
    <>
   
      <section className="hero-section">
        <div className="hero-overlay"></div>

        <Container className="hero-content text-center">
        <div className="hero-icons mb-3">
  <FaTruckMoving />
  <FaTractor />
  <FaHardHat />
</div>
          <p className="hero-subtitle">
            Top-Of-The-Line Services Ready At Flexible Rates Around
          </p>

          <h1>
            Your One-Stop Source For All
            <br />
            Equipment  Needs
          </h1>

          <div className="hero-line"></div>
        </Container>
      </section>

     

<Container>
  <div className="search-box shadow-lg">

    <Row className="g-4 align-items-center text-center">

      <Col lg={3} md={6}>
        <FaUserTie
          size={42}
          style={{ color: "var(--secondary-color)" }}
        />

        <h5 className="fw-bold mt-3 mb-1">
          Dealer
        </h5>

        <div
          className="mx-auto"
          style={{
            width: "50px",
            height: "3px",
            background: "var(--secondary-color)",
          }}
        ></div>

        <small className="text-dark d-block mt-2">
          Business Partner
        </small>
      </Col>

      <Col lg={3} md={6}>
        <FaUsers
          size={42}
          style={{ color: "var(--secondary-color)" }}
        />

        <h5 className="fw-bold mt-3 mb-1">
          Customer
        </h5>

        <div
          className="mx-auto"
          style={{
            width: "50px",
            height: "3px",
            background: "var(--secondary-color)",
          }}
        ></div>

        <small className="text-dark d-block mt-2">
          Book Equipment
        </small>
      </Col>

      <Col lg={3} md={6}>
        <FaTruckMoving
          size={42}
          style={{ color: "var(--secondary-color)" }}
        />

        <h5 className="fw-bold mt-3 mb-1">
          Driver
        </h5>

        <div
          className="mx-auto"
          style={{
            width: "50px",
            height: "3px",
            background: "var(--secondary-color)",
          }}
        ></div>

        <small className="text-dark d-block mt-2">
          Delivery Partner
        </small>
      </Col>

      <Col lg={3} md={6}>
        <Button
          className="w-100 border-0 rounded-0 fw-bold"
          style={{
            height: "60px",
            background: "var(--secondary-color)",
            color: "#fff",
          }}
        >
          Download Our App
          <FaArrowRight className="ms-2" />
        </Button>
      </Col>

    </Row>

  </div>
</Container>
      <section className="category-section">

    <Container>

        <div className="section-title text-center">

            <span>We Promise To Find You The Right Equipment</span>

            <h2>Browse Machinery Categories</h2>

            <div className="title-line mx-auto"></div>

        </div>

        <Row className="g-4 mt-4">

            {categories.map((item, index) => (

                <Col lg={4} md={6} key={index}>

                    <div className="category-card">

                        <img
                            src={item.image}
                            alt={item.title}
                        />

                        <div className="category-name">
                            {item.title}
                        </div>

                    </div>

                </Col>

            ))}

        </Row>

        <div className="text-center mt-5">


        </div>

    </Container>

</section>
<section className="counter-section">
  <div className="counter-overlay"></div>

  <Container>
    <Row className="g-4">

      <Col lg={3} md={6}>
        <div className="counter-box">
          <div className="counter-top">
            <h2>3.4k</h2>
            <FaTools />
          </div>

          <h4>Helping Projects Done</h4>

          <p>
            Best thing about Antek is to earn some extra revenue on their
            equipments.
          </p>
        </div>
      </Col>

      <Col lg={3} md={6}>
        <div className="counter-box">
          <div className="counter-top">
            <h2>25+</h2>
            <FaUserTie />
          </div>

          <h4>Years In Business</h4>

          <p>
            Best thing about Antek is to earn some extra revenue on their
            equipments.
          </p>
        </div>
      </Col>

      <Col lg={3} md={6}>
        <div className="counter-box">
          <div className="counter-top">
            <h2>18+</h2>
            <FaAward />
          </div>

          <h4>Received Awards So far</h4>

          <p>
            Best thing  is to earn some extra revenue on their
            equipments.
          </p>
        </div>
      </Col>

      <Col lg={3} md={6}>
        <div className="counter-box">
          <div className="counter-top">
            <h2>5.9%</h2>
            <FaBuilding />
          </div>

          <h4>Earned Revenue This Year</h4>

          <p>
            Best thing  is to earn some extra revenue on their
            equipments.
          </p>
        </div>
      </Col>

    </Row>
  </Container>
</section>
<section className="about-section">
  <Container>
    <Row className="align-items-center g-5">

      <Col lg={6}>
        <div className="about-images">

          <img
            src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=700&auto=format&fit=crop"
            alt=""
            className="img-main"
          />

          <img
            src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=700&auto=format&fit=crop"
            alt=""
            className="img-small"
          />

          

        </div>
      </Col>

      <Col lg={6}>

        <span className="about-tag">
          About Services
        </span>

        <h1 className="about-title">
         Building Trust Through Technology & Innovation
          <br />
       
        </h1>

        <div className="title-line"></div>

        <p className="about-text">
        We are committed to delivering dependable services and maintaining high standards across our platform.
        </p>

        <Row className="mt-4">

          <Col sm={6}>
            <div className="feature-item">
              <h5>Customer First Approach</h5>
              <p>
                Our priority is to understand user needs and provide simple, effective solutions.
              </p>
            </div>
          </Col>

          <Col sm={6}>
            <div className="feature-item">
              <h5>Security & Responsibility</h5>
              <p>
              We value user trust by ensuring a safe, transparent, and responsible digital experience.
              </p>
            </div>
          </Col>

        </Row>

      </Col>

    </Row>
  </Container>
</section>

   
    </>
  );
};

export default Home;